import { A } from "@solidjs/router";
import { dispatchGlobalEvent } from "@storytell/events";
import { StDropdown, StDropdownItem, StDropdownTrigger } from "@storytell/ui/dropdown";
import { HeroHeading } from "@storytell/ui/marketing";
import { TbLoader2, TbLogout } from "solid-icons/tb";
import { Match, Show, Switch } from "solid-js";
import { Avatar } from "~/components/avatar";
import { Logo } from "~/components/brand";
import { PromptBarWithStatus, type PromptSubmission } from "~/components/prompt";
import { PromptBarAssetsCTA } from "~/components/prompt/PromptBarAssetsCTA";
import { useWire } from "~/wire";

export const ChatHomepage = (props: { onSubmit: (submission: PromptSubmission) => void }) => {
  const wire = useWire();
  return (
    <main data-testid="initial-welcome-state" class="z-10 flex-1 flex flex-col items-center">
      <nav class="w-full flex justify-between items-center pl-10 pr-10 py-5">
        <div class="flex gap-10 tracking-wider items-center text-sm">
          <Logo class="mx-auto" size={120} />

          <a href="/" class="hover:underline underline-offset-2">
            Platform
          </a>
          <a href="/pricing" class="hover:underline underline-offset-2">
            Pricing
          </a>
          <a href="https://web.storytell.ai/book-a-demo" class="hover:underline underline-offset-2">
            Book Enterprise Demo
          </a>
        </div>

        <div class="flex gap-4 items-center h-8">
          <Switch>
            <Match when={!wire.auth.isReady()}>
              <TbLoader2 class="animate-spin size-6" />
            </Match>
            <Match when={!wire.auth.isRegistered()}>
              <A href="/auth/login" class="font-medium px-2 py-1">
                Log in
              </A>
              <A href="/auth/signup" class="font-medium px-4 py-1 rounded text-on-brand bg-brand shadow-xl">
                Sign up
              </A>
            </Match>
            <Match when={true}>
              <StDropdown
                modal={false}
                placement="bottom-end"
                gutter={5}
                contentProps={{
                  class: "z-10",
                }}
                content={
                  <>
                    <div class="text-sm font-medium text-secondary-text rounded-md px-2 py-2 pb-1">
                      {wire.auth.user()?.displayName || "You"}
                    </div>
                    <Show when={wire.auth.user()?.primaryEmail !== wire.auth.user()?.displayName}>
                      <div class="text-muted-text text-sm px-2 pb-2">{wire.auth.user()?.primaryEmail}</div>
                    </Show>
                    <StDropdownItem
                      onClick={() => wire.auth.methods.signOut()}
                      class="cursor-pointer flex items-center gap-3 hover:bg-canvas-hover rounded-md px-2 py-2"
                    >
                      <TbLogout class="size-5" />
                      Sign out
                    </StDropdownItem>
                  </>
                }
              >
                <StDropdownTrigger class="cursor-pointer rounded-full">
                  <Avatar
                    class="ring-3"
                    src={wire.auth.user()?.avatarUrl}
                    name={wire.auth.user()?.displayName}
                    size="sm"
                  />
                </StDropdownTrigger>
              </StDropdown>
            </Match>
          </Switch>
        </div>
      </nav>

      <div class="text-center w-full">
        <div class="h-14" aria-hidden />
        <div>
          <HeroHeading />
        </div>
        <div class="h-12" aria-hidden />
        {/* Centered prompt bar in initial state */}
        <div class="w-full mx-auto space-y-4 px-4 sm:px-6 md:px-8 lg:px-0">
          {/* TODO: @andi streaming Add streaming state */}
          <PromptBarWithStatus
            onSubmit={props.onSubmit}
            // streamingState={streamingState}
            onStopStreaming={() => {}}
            //  chat={chat}
          />

          <div class="flex justify-center">
            <PromptBarAssetsCTA
              onOpenFilePicker={() => {
                dispatchGlobalEvent("open-file-picker", undefined);
              }}
            />
          </div>
        </div>
      </div>
    </main>
  );
};
